import { render, staticRenderFns } from "./menuNumC.vue?vue&type=template&id=6a6902df&scoped=true"
import script from "./menuNumC.vue?vue&type=script&lang=js"
export * from "./menuNumC.vue?vue&type=script&lang=js"
import style0 from "./menuNumC.vue?vue&type=style&index=0&id=6a6902df&prod&scoped=true&lang=css"
import style1 from "./menuNumC.vue?vue&type=style&index=1&id=6a6902df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6902df",
  null
  
)

export default component.exports